import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchNoteBuilds = params => {
    return axios.get('/api/v1/note_builds/', { params });
};

export const createNoteBuilds = (book, data) => {
    return axios.post('/api/v1/note_builds/', { book, ...data });
};

export const checkNoteBuildsQueue = (book, params = {}) => {
    params = {
        book,
        build_type: 'subtitles',
        ...params
    };
    return axios.get('/api/v1/note_builds/in_queue/', { params });
};
